import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'


Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      leftHanded:false
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
